module.exports = __webpack_public_path__ + "img/LY.e707148f.svg";